/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
(function () {
  var container, button, menu;
  container = document.querySelector("#site-navigation");
  if (!container) {
    return;
  }

  button = container.getElementsByTagName("button")[0];
  if ("undefined" === typeof button) {
    return;
  }

  menu = container.getElementsByTagName("ul")[0];

  // Hide menu toggle button if menu is empty and return early.
  if ("undefined" === typeof menu) {
    button.style.display = "none";
    return;
  }

  menu.setAttribute("aria-expanded", "false");
  if (-1 === menu.className.indexOf("nav-menu")) {
    menu.className += " nav-menu";
  }

  button.onclick = function () {
    if (-1 !== container.className.indexOf("toggled")) {
      container.className = container.className.replace(" toggled", "");
      button.setAttribute("aria-expanded", "false");
      menu.setAttribute("aria-expanded", "false");
    } else {
      container.className += " toggled";
      button.setAttribute("aria-expanded", "true");
      menu.setAttribute("aria-expanded", "true");
    }
  };

  const downLevelButtons = menu.querySelectorAll(
    ".js-c-mainmenu__button_downLevel"
  );

  downLevelButtons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      button.classList.toggle("toggled");
      const submenu = button.nextElementSibling;
      submenu.classList.toggle("show");
    });
  });

  const upLevelButtons = menu.querySelectorAll(
    ".js-c-mainmenu__button_upLevel"
  );
  upLevelButtons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      const submenu = button.closest(".sub-menu");
      submenu.classList.remove("show");
    });
  });
})();

const nav = document.querySelector(".l-header_medium .l-header__nav");

if (nav) {
  document.addEventListener("scroll", function (e) {
    const yOffset = window.scrollY;

    if (yOffset > 96) {
      nav.classList.add("stick-nav");
    } else {
      nav.classList.remove("stick-nav");
    }
  });
}
